"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remToPixel = exports["default"] = void 0;
/**
 * Function converts rem values to pixel (number) with default base font size as 16
 * @param {num | string} [rem=0] - This is the rem value that needs to be converted to pixels. Accept string or number. Default value is 0.
 * @param {num} [baseFontSize=16] - This is the base or root font size to be used to calculate and convert the rem value to pixels. Default value is 16
 * @returns {num} - Pixel value converted from rem
 */
var remToPixel = exports.remToPixel = function remToPixel() {
  var rem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var baseFontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  var sanitisedRem = typeof rem === 'string' ? Number(rem.replace(/\D+/g, '')) : rem;
  var sanitisedBaseFontSize = typeof baseFontSize === 'string' ? Number(baseFontSize.replace(/\D+/g, '')) : baseFontSize;
  var calcVal = sanitisedRem * sanitisedBaseFontSize;
  return calcVal;
};
var _default = exports["default"] = remToPixel;